import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JkFullscreenService {

  constructor() { }

  toggleFullscreen(element: HTMLElement) {
    if (!document.fullscreenElement) {
      element.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  }
}
